import JSEncrypt from 'jsencrypt';

let cachedPublicKey: string | null = null;
/** 进行中的公钥请求。并行加密多个密码时共用这一次，避免重复打 /auth/public-key */
let inflightPublicKey: Promise<string> | null = null;

interface PublicKeyData {
    publicKey: string;
}

/** 清除缓存的公钥（后端重启后需重新获取） */
export function clearPasswordPublicKeyCache() {
    cachedPublicKey = null;
}

async function fetchPublicKey(forceRefresh = false): Promise<string> {
    if (!forceRefresh && cachedPublicKey) {
        return cachedPublicKey;
    }
    if (inflightPublicKey) {
        return inflightPublicKey;
    }
    inflightPublicKey = httpGet<PublicKeyData>(ServerType.Base, {
        url: '/auth/public-key',
        params: { t: Date.now() },
        config: {
            headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
            },
        },
    })
        .then((data) => {
            if (!data?.publicKey) {
                throw new Error('获取加密公钥失败');
            }
            cachedPublicKey = data.publicKey;
            return cachedPublicKey;
        })
        .finally(() => {
            inflightPublicKey = null;
        });
    return inflightPublicKey;
}

/** 使用 RSA 公钥加密密码，提交给后端前调用 */
export async function encryptPassword(password: string): Promise<string> {
    // 每次提交密码前强制刷新公钥，避免后端重启后前端仍使用旧公钥导致 RSA 解密失败。
    const publicKey = await fetchPublicKey(true);
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(publicKey);
    const encrypted = encryptor.encrypt(password);
    if (!encrypted) {
        clearPasswordPublicKeyCache();
        throw new Error('密码加密失败');
    }
    return encrypted;
}
